import { render, staticRenderFns } from "./ProductItemDesignSwatch.vue?vue&type=template&id=6c44d3a6&"
import script from "./ProductItemDesignSwatch.vue?vue&type=script&lang=js&"
export * from "./ProductItemDesignSwatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports